import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import DailyReportTableFilter from "../Filters/DailyReportTableFilter";
import { ColumnHelper } from "util/TableHelper";
import { Table, Empty, Col, Row, Tooltip, message } from "antd";
import { BarsOutlined, FileExcelOutlined,MenuUnfoldOutlined } from "@ant-design/icons";
import config from "../../util/ApiforContext";
import { useHistory } from "react-router-dom";
const DailyBalanceReport = (props) => {
const history = useHistory();

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [currencyLlist, setCurrencyList] = useState([]);
  const [isDigitReportFromEndOfDay, setIsDigitReportFromEndOfDay] = useState();

  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    startDate: null,
    endDate:null
  });

  useEffect(() => getTableData(), [tableDataQueryOptions]);
  const detailTableBankAccounts = (data) => {
    const columns = [
      {
        title: "Banka",
        dataIndex: "bankLogo",
        key: "bankLogo",
        render: (text, row, index) => {
          return (
            <div style={{ width: 100 }}>
              {" "}
              <img src={text}></img>
            </div>
          );
        },
      },
      currencyLlist.includes(1) ?
      {
        title: "TRY Bakiye",
        dataIndex: "amount",
        key: "amount",
        align: "center",
        render: (text, record) => {
          return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
        } 
      } : {},
      currencyLlist.includes(2) ?
      {
        title: "USD Bakiye",
        dataIndex: "amountUSD",
        key: "amountUSD",
        align: "center",
        render: (text, record) => {
          return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
        } 
      } : {},
      currencyLlist.includes(3) ?
      {
        title: "EUR Bakiye",
        dataIndex: "amountEUR",
        key: "amountEUR",
        align: "center",
        render: (text, record) => {
          return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
        } 
      } : {},
      currencyLlist.includes(4) ?
      {
        title: "GBP Bakiye",
        dataIndex: "amountGBP",
        key: "amountGBP",
        align: "center",
        render: (text, record) => {
          return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
        } 
      } : {},
      currencyLlist.includes(11) ?
      {
        title: "XAU Bakiye",
        dataIndex: "amountXAU",
        key: "amountXAU",
        align: "center",
        render: (text, record) => {
          return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
        } 
      } : {},
      currencyLlist.includes(16) ?
      {
        title: "AUD Bakiye",
        dataIndex: "amountAUD",
        key: "amountAUD",
        align: "center",
        render: (text, record) => {
          return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
        } 
      } : {},
      {
        title: "Hesap Detay",
        dataIndex: "operation",
        align: "center",
        render: (text, record) =>
            <a
              onClick={() => {
                GoDailyAccountReport(record.bankId,moment(record.transactionDate).format("DD.MM.YYYY"));
              }}
              style={{ fontSize: "130%", color: "red" }}
            >
              <MenuUnfoldOutlined />
            </a>
      },
    ];
    return (
      <Table
        columns={columns}
        locale={{
          emptyText: (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" />
          ),
        }}
        rowKey={(record) => record.BankId + "-" + record.memberWorkplaceNumber}
        filterable={true}
        sortable={true}
        pagination={false}
        dataSource={data}
        size="small"
      />
    );
  };
  const GoDailyAccountReport = (value,date) => {
    history.push(`monthly-report-account/${value}/${date}`);
  };
  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }
    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = () => {
   
    
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then((response) => {
      if (response.success) {
        setIsDigitReportFromEndOfDay(response.data.isDigitReportFromEndOfDay)
      }
    });
    
    RequestHandler.get(`/TenantAccount/CurrencyBankListTotal`).then(
      (response) => {
        var newList = [];
        response.map((item) => {
          newList.push(item.currencyId);
        })
        setCurrencyList(newList);
      }
    );
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;
    if(
      (tableDataQueryOptions.endDate !== null && tableDataQueryOptions.endDate !== undefined) &&
      tableDataQueryOptions.bankFilterId &&
      (
        (tableDataQueryOptions.amountMin !== null && tableDataQueryOptions.amountMin !== undefined) ||
        (tableDataQueryOptions.amountMax !== null && tableDataQueryOptions.amountMax !== undefined) ||
        (tableDataQueryOptions.amountMaxUSD !== null && tableDataQueryOptions.amountMaxUSD !== undefined) ||
        (tableDataQueryOptions.amountMinUSD !== null && tableDataQueryOptions.amountMinUSD !== undefined) ||
        (tableDataQueryOptions.amountMaxXAU !== null && tableDataQueryOptions.amountMaxXAU !== undefined) ||
        (tableDataQueryOptions.amountMinXAU !== null && tableDataQueryOptions.amountMinXAU !== undefined) ||
        (tableDataQueryOptions.amountMaxAUD !== null && tableDataQueryOptions.amountMaxAUD !== undefined) ||
        (tableDataQueryOptions.amountMinAUD !== null && tableDataQueryOptions.amountMinAUD !== undefined) ||
        (tableDataQueryOptions.amountMinEUR !== null && tableDataQueryOptions.amountMinEUR !== undefined) ||
        (tableDataQueryOptions.amountMaxEUR !== null && tableDataQueryOptions.amountMaxEUR !== undefined) ||
        (tableDataQueryOptions.amountMinGBP !== null && tableDataQueryOptions.amountMinGBP !== undefined) ||
        (tableDataQueryOptions.amountMaxGBP !== null && tableDataQueryOptions.amountMaxGBP !== undefined)
      )){
      RequestHandler.get(
        `/DailyBalanceReport?isBankMonthly=true&bankFilterId=${tableDataQueryOptions.bankFilterId}&isOdataQuery=true
        &startDate=${moment(tableDataQueryOptions.startDate).format("DD.MM.YYYY")}
        &endDate=${moment(tableDataQueryOptions.endDate).format("DD.MM.YYYY")}
        ${tableDataQueryOptions.amountMin !== null ? "&amountMin=" + tableDataQueryOptions.amountMin : ""}
        ${tableDataQueryOptions.amountMax !== null ? "&amountMax=" + tableDataQueryOptions.amountMax : ""}
        ${tableDataQueryOptions.amountMinUSD !== null ? "&amountMinUSD=" + tableDataQueryOptions.amountMinUSD : ""}
        ${tableDataQueryOptions.amountMaxUSD !== null ? "&amountMaxUSD=" + tableDataQueryOptions.amountMaxUSD : ""}
        ${tableDataQueryOptions.amountMinXAU !== null ? "&amountMinXAU=" + tableDataQueryOptions.amountMinXAU : ""}
        ${tableDataQueryOptions.amountMaxXAU !== null ? "&amountMaxXAU=" + tableDataQueryOptions.amountMaxXAU : ""}
        ${tableDataQueryOptions.amountMinAUD !== null ? "&amountMinAUD=" + tableDataQueryOptions.amountMinAUD : ""}
        ${tableDataQueryOptions.amountMaxAUD !== null ? "&amountMaxAUD=" + tableDataQueryOptions.amountMaxAUD : ""}
        ${tableDataQueryOptions.amountMinEUR !== null ? "&amountMinEUR=" + tableDataQueryOptions.amountMinEUR : ""}
        ${tableDataQueryOptions.amountMaxEUR !== null ? "&amountMaxEUR=" + tableDataQueryOptions.amountMaxEUR : ""}
        ${tableDataQueryOptions.amountMinGBP !== null ? "&amountMinGBP=" + tableDataQueryOptions.amountMinGBP : ""}
        ${tableDataQueryOptions.amountMaxGBP !== null ? "&amountMaxGBP=" + tableDataQueryOptions.amountMaxGBP : ""}
        &${getFilterQuery()}&$count=true&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
    } 
    else if((tableDataQueryOptions.endDate != null && tableDataQueryOptions.endDate != undefined) && tableDataQueryOptions.bankFilterId && (
      (tableDataQueryOptions.amountMin != null && tableDataQueryOptions.amountMin != undefined )|| 
      (tableDataQueryOptions.amountMax != null && tableDataQueryOptions.amountMax != undefined) ||
      (tableDataQueryOptions.amountMaxUSD != null && tableDataQueryOptions.amountMaxUSD != undefined) ||
      (tableDataQueryOptions.amountMinUSD != null && tableDataQueryOptions.amountMinUSD != undefined) ||
      (tableDataQueryOptions.amountMaxXAU != null && tableDataQueryOptions.amountMaxXAU != undefined) ||
      (tableDataQueryOptions.amountMinXAU != null && tableDataQueryOptions.amountMinXAU != undefined) ||
      (tableDataQueryOptions.amountMaxAUD != null && tableDataQueryOptions.amountMaxAUD != undefined) ||
      (tableDataQueryOptions.amountMinAUD != null && tableDataQueryOptions.amountMinAUD != undefined) ||
      (tableDataQueryOptions.amountMinEUR != null && tableDataQueryOptions.amountMinEUR != undefined) ||
      (tableDataQueryOptions.amountMaxEUR != null && tableDataQueryOptions.amountMaxEUR != undefined) ||
      (tableDataQueryOptions.amountMinGBP != null && tableDataQueryOptions.amountMinGBP != undefined) ||
      (tableDataQueryOptions.amountMaxGBP != null && tableDataQueryOptions.amountMaxGBP != undefined)
      )){
      RequestHandler.get(
        `/DailyBalanceReport?isBankMonthly=true
        ${tableDataQueryOptions.amountMin !== null ? "&amountMin=" + tableDataQueryOptions.amountMin : ""}
        ${tableDataQueryOptions.amountMax !== null ? "&amountMax=" + tableDataQueryOptions.amountMax : ""}
        ${tableDataQueryOptions.amountMinUSD !== null ? "&amountMinUSD=" + tableDataQueryOptions.amountMinUSD : ""}
        ${tableDataQueryOptions.amountMaxUSD !== null ? "&amountMaxUSD=" + tableDataQueryOptions.amountMaxUSD : ""}
        ${tableDataQueryOptions.amountMinXAU !== null ? "&amountMinXAU=" + tableDataQueryOptions.amountMinXAU : ""}
        ${tableDataQueryOptions.amountMaxXAU !== null ? "&amountMaxXAU=" + tableDataQueryOptions.amountMaxXAU : ""}
        ${tableDataQueryOptions.amountMinAUD !== null ? "&amountMinAUD=" + tableDataQueryOptions.amountMinAUD : ""}
        ${tableDataQueryOptions.amountMaxAUD !== null ? "&amountMaxAUD=" + tableDataQueryOptions.amountMaxAUD : ""}
        ${tableDataQueryOptions.amountMinEUR !== null ? "&amountMinEUR=" + tableDataQueryOptions.amountMinEUR : ""}
        ${tableDataQueryOptions.amountMaxEUR !== null ? "&amountMaxEUR=" + tableDataQueryOptions.amountMaxEUR : ""}
        ${tableDataQueryOptions.amountMinGBP !== null ? "&amountMinGBP=" + tableDataQueryOptions.amountMinGBP : ""}
        ${tableDataQueryOptions.amountMaxGBP !== null ? "&amountMaxGBP=" + tableDataQueryOptions.amountMaxGBP : ""}
        &bankFilterId=${tableDataQueryOptions.bankFilterId}&isOdataQuery=true&startDate=${moment(tableDataQueryOptions.startDate).format("DD.MM.YYYY")}&endDate=${moment(tableDataQueryOptions.endDate).format("DD.MM.YYYY")}&$count=true&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
    }
    else if((tableDataQueryOptions.endDate != null && tableDataQueryOptions.endDate != undefined) && tableDataQueryOptions.bankFilterId){
      RequestHandler.get(
        `/DailyBalanceReport?isBankMonthly=true&bankFilterId=${tableDataQueryOptions.bankFilterId}&isOdataQuery=true&startDate=${moment(tableDataQueryOptions.startDate).format("DD.MM.YYYY")}&endDate=${moment(tableDataQueryOptions.endDate).format("DD.MM.YYYY")}&$count=true&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
    }
    else if((tableDataQueryOptions.endDate != null && tableDataQueryOptions.endDate != undefined) && (
      (tableDataQueryOptions.amountMin != null && tableDataQueryOptions.amountMin != undefined )|| 
      (tableDataQueryOptions.amountMax != null && tableDataQueryOptions.amountMax != undefined) ||
      (tableDataQueryOptions.amountMaxUSD != null && tableDataQueryOptions.amountMaxUSD != undefined) ||
      (tableDataQueryOptions.amountMinUSD != null && tableDataQueryOptions.amountMinUSD != undefined) ||
      (tableDataQueryOptions.amountMaxXAU != null && tableDataQueryOptions.amountMaxXAU != undefined) ||
      (tableDataQueryOptions.amountMinXAU != null && tableDataQueryOptions.amountMinXAU != undefined) ||
      (tableDataQueryOptions.amountMaxAUD != null && tableDataQueryOptions.amountMaxAUD != undefined) ||
      (tableDataQueryOptions.amountMinAUD != null && tableDataQueryOptions.amountMinAUD != undefined) ||
      (tableDataQueryOptions.amountMinEUR != null && tableDataQueryOptions.amountMinEUR != undefined) ||
      (tableDataQueryOptions.amountMaxEUR != null && tableDataQueryOptions.amountMaxEUR != undefined) ||
      (tableDataQueryOptions.amountMinGBP != null && tableDataQueryOptions.amountMinGBP != undefined) ||
      (tableDataQueryOptions.amountMaxGBP != null && tableDataQueryOptions.amountMaxGBP != undefined)
      ))
    {
      RequestHandler.get(
        `/DailyBalanceReport?isBankMonthly=true&isOdataQuery=true
        ${tableDataQueryOptions.amountMin !== null ? "&amountMin=" + tableDataQueryOptions.amountMin : ""}
        ${tableDataQueryOptions.amountMax !== null ? "&amountMax=" + tableDataQueryOptions.amountMax : ""}
        ${tableDataQueryOptions.amountMinUSD !== null ? "&amountMinUSD=" + tableDataQueryOptions.amountMinUSD : ""}
        ${tableDataQueryOptions.amountMaxUSD !== null ? "&amountMaxUSD=" + tableDataQueryOptions.amountMaxUSD : ""}
        ${tableDataQueryOptions.amountMinXAU !== null ? "&amountMinXAU=" + tableDataQueryOptions.amountMinXAU : ""}
        ${tableDataQueryOptions.amountMaxXAU !== null ? "&amountMaxXAU=" + tableDataQueryOptions.amountMaxXAU : ""}
        ${tableDataQueryOptions.amountMinAUD !== null ? "&amountMinAUD=" + tableDataQueryOptions.amountMinAUD : ""}
        ${tableDataQueryOptions.amountMaxAUD !== null ? "&amountMaxAUD=" + tableDataQueryOptions.amountMaxAUD : ""}
        ${tableDataQueryOptions.amountMinEUR !== null ? "&amountMinEUR=" + tableDataQueryOptions.amountMinEUR : ""}
        ${tableDataQueryOptions.amountMaxEUR !== null ? "&amountMaxEUR=" + tableDataQueryOptions.amountMaxEUR : ""}
        ${tableDataQueryOptions.amountMinGBP !== null ? "&amountMinGBP=" + tableDataQueryOptions.amountMinGBP : ""}
        ${tableDataQueryOptions.amountMaxGBP !== null ? "&amountMaxGBP=" + tableDataQueryOptions.amountMaxGBP : ""}
        &startDate=${moment(tableDataQueryOptions.startDate).format("DD.MM.YYYY")}
        &endDate=${moment(tableDataQueryOptions.endDate).format("DD.MM.YYYY")}&$count=true&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
    }
    else if((tableDataQueryOptions.endDate != null && tableDataQueryOptions.endDate != undefined))
    {
      RequestHandler.get(
        `/DailyBalanceReport?isBankMonthly=true&isOdataQuery=true&startDate=${moment(tableDataQueryOptions.startDate).format("DD.MM.YYYY")}&endDate=${moment(tableDataQueryOptions.endDate).format("DD.MM.YYYY")}&$count=true&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
    }
    else if(tableDataQueryOptions.bankFilterId != null && (
      (tableDataQueryOptions.amountMin != null && tableDataQueryOptions.amountMin != undefined )|| 
      (tableDataQueryOptions.amountMax != null && tableDataQueryOptions.amountMax != undefined)||
      (tableDataQueryOptions.amountMaxUSD != null && tableDataQueryOptions.amountMaxUSD != undefined) ||
      (tableDataQueryOptions.amountMinUSD != null && tableDataQueryOptions.amountMinUSD != undefined) ||
      (tableDataQueryOptions.amountMaxXAU != null && tableDataQueryOptions.amountMaxXAU != undefined) ||
      (tableDataQueryOptions.amountMinXAU != null && tableDataQueryOptions.amountMinXAU != undefined) ||
      (tableDataQueryOptions.amountMaxAUD != null && tableDataQueryOptions.amountMaxAUD != undefined) ||
      (tableDataQueryOptions.amountMinAUD != null && tableDataQueryOptions.amountMinAUD != undefined) ||
      (tableDataQueryOptions.amountMinEUR != null && tableDataQueryOptions.amountMinEUR != undefined) ||
      (tableDataQueryOptions.amountMaxEUR != null && tableDataQueryOptions.amountMaxEUR != undefined) ||
      (tableDataQueryOptions.amountMinGBP != null && tableDataQueryOptions.amountMinGBP != undefined) ||
      (tableDataQueryOptions.amountMaxGBP != null && tableDataQueryOptions.amountMaxGBP != undefined)
      )){
      RequestHandler.get(
        `/DailyBalanceReport?isBankMonthly=true&bankFilterId=${tableDataQueryOptions.bankFilterId}
        ${tableDataQueryOptions.amountMin !== null ? "&amountMin=" + tableDataQueryOptions.amountMin : ""}
        ${tableDataQueryOptions.amountMax !== null ? "&amountMax=" + tableDataQueryOptions.amountMax : ""}
        ${tableDataQueryOptions.amountMinUSD !== null ? "&amountMinUSD=" + tableDataQueryOptions.amountMinUSD : ""}
        ${tableDataQueryOptions.amountMaxUSD !== null ? "&amountMaxUSD=" + tableDataQueryOptions.amountMaxUSD : ""}
        ${tableDataQueryOptions.amountMinXAU !== null ? "&amountMinXAU=" + tableDataQueryOptions.amountMinXAU : ""}
        ${tableDataQueryOptions.amountMaxXAU !== null ? "&amountMaxXAU=" + tableDataQueryOptions.amountMaxXAU : ""}
        ${tableDataQueryOptions.amountMinAUD !== null ? "&amountMinAUD=" + tableDataQueryOptions.amountMinAUD : ""}
        ${tableDataQueryOptions.amountMaxAUD !== null ? "&amountMaxAUD=" + tableDataQueryOptions.amountMaxAUD : ""}
        ${tableDataQueryOptions.amountMinEUR !== null ? "&amountMinEUR=" + tableDataQueryOptions.amountMinEUR : ""}
        ${tableDataQueryOptions.amountMaxEUR !== null ? "&amountMaxEUR=" + tableDataQueryOptions.amountMaxEUR : ""}
        ${tableDataQueryOptions.amountMinGBP !== null ? "&amountMinGBP=" + tableDataQueryOptions.amountMinGBP : ""}
        ${tableDataQueryOptions.amountMaxGBP !== null ? "&amountMaxGBP=" + tableDataQueryOptions.amountMaxGBP : ""}
        &isOdataQuery=true&$count=true&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
    }
    else if(tableDataQueryOptions.bankFilterId != null){
      RequestHandler.get(
        `/DailyBalanceReport?isBankMonthly=true&bankFilterId=${tableDataQueryOptions.bankFilterId}&isOdataQuery=true&$count=true&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
    }
   
    else if(
      (tableDataQueryOptions.amountMin != null && tableDataQueryOptions.amountMin != undefined )|| 
      (tableDataQueryOptions.amountMax != null && tableDataQueryOptions.amountMax != undefined) ||
      (tableDataQueryOptions.amountMaxUSD != null && tableDataQueryOptions.amountMaxUSD != undefined) ||
      (tableDataQueryOptions.amountMinUSD != null && tableDataQueryOptions.amountMinUSD != undefined) ||
      (tableDataQueryOptions.amountMaxXAU != null && tableDataQueryOptions.amountMaxXAU != undefined) ||
      (tableDataQueryOptions.amountMinXAU != null && tableDataQueryOptions.amountMinXAU != undefined) ||
      (tableDataQueryOptions.amountMaxAUD != null && tableDataQueryOptions.amountMaxAUD != undefined) ||
      (tableDataQueryOptions.amountMinAUD != null && tableDataQueryOptions.amountMinAUD != undefined) ||
      (tableDataQueryOptions.amountMinEUR != null && tableDataQueryOptions.amountMinEUR != undefined) ||
      (tableDataQueryOptions.amountMaxEUR != null && tableDataQueryOptions.amountMaxEUR != undefined) ||
      (tableDataQueryOptions.amountMinGBP != null && tableDataQueryOptions.amountMinGBP != undefined) ||
      (tableDataQueryOptions.amountMaxGBP != null && tableDataQueryOptions.amountMaxGBP != undefined)){
      RequestHandler.get(
        `/DailyBalanceReport?isBankMonthly=true
        ${tableDataQueryOptions.amountMin !== null ? "&amountMin=" + tableDataQueryOptions.amountMin : ""}
        ${tableDataQueryOptions.amountMax !== null ? "&amountMax=" + tableDataQueryOptions.amountMax : ""}
        ${tableDataQueryOptions.amountMinUSD !== null ? "&amountMinUSD=" + tableDataQueryOptions.amountMinUSD : ""}
        ${tableDataQueryOptions.amountMaxUSD !== null ? "&amountMaxUSD=" + tableDataQueryOptions.amountMaxUSD : ""}
        ${tableDataQueryOptions.amountMinXAU !== null ? "&amountMinXAU=" + tableDataQueryOptions.amountMinXAU : ""}
        ${tableDataQueryOptions.amountMaxXAU !== null ? "&amountMaxXAU=" + tableDataQueryOptions.amountMaxXAU : ""}
        ${tableDataQueryOptions.amountMinAUD !== null ? "&amountMinAUD=" + tableDataQueryOptions.amountMinAUD : ""}
        ${tableDataQueryOptions.amountMaxAUD !== null ? "&amountMaxAUD=" + tableDataQueryOptions.amountMaxAUD : ""}
        ${tableDataQueryOptions.amountMinEUR !== null ? "&amountMinEUR=" + tableDataQueryOptions.amountMinEUR : ""}
        ${tableDataQueryOptions.amountMaxEUR !== null ? "&amountMaxEUR=" + tableDataQueryOptions.amountMaxEUR : ""}
        ${tableDataQueryOptions.amountMinGBP !== null ? "&amountMinGBP=" + tableDataQueryOptions.amountMinGBP : ""}
        ${tableDataQueryOptions.amountMaxGBP !== null ? "&amountMaxGBP=" + tableDataQueryOptions.amountMaxGBP : ""}
        &isOdataQuery=true&$count=true&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
    }
    else{
      RequestHandler.get(
        `/DailyBalanceReport?isBankMonthly=true&$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
    }

  if (props.onFilterChange) {
    props.onFilterChange(tableDataQueryOptions);
  }
  };
  
  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query,model) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query,endDate: model.endDate,startDate: model.startDate,bankFilterId: model.bankId,
        amountMin : model.amountMin, amountMax : model.amountMax,
        amountMinUSD : model.amountMinUSD, amountMaxUSD : model.amountMaxUSD, 
        amountMinEUR : model.amountMinEUR, amountMaxEUR : model.amountMaxEUR, 
        amountMinGBP : model.amountMinGBP, amountMaxGBP : model.amountMaxGBP,
        amountMinXAU : model.amountMinXAU, amountMaxXAU : model.amountMaxXAU, 
        amountMinAUD : model.amountMinAUD, amountMaxAUD : model.amountMaxAUD };
    });
  };
  
  const tableColumns = [
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      key: "transactionDate",
      align: "center",
      render: (data, row, index) => moment(data).format("MMMM YYYY"),
    },
    currencyLlist.includes(1) ?
    {
      title: "TRY Bakiye",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      render: (text, record) => {
        return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
      } 
    } : {},
    currencyLlist.includes(2) ?
    {
      title: "USD Bakiye",
      dataIndex: "amountUSD",
      key: "amountUSD",
      align: "center",
      render: (text, record) => {
        return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
      } 
    } : {},
    currencyLlist.includes(3) ?
    {
      title: "EUR Bakiye",
      dataIndex: "amountEUR",
      key: "amountEUR",
      align: "center",
      render: (text, record) => {
        return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
      } 
    } : {},
    currencyLlist.includes(4) ?
    {
      title: "GBP Bakiye",
      dataIndex: "amountGBP",
      key: "amountGBP",
      align: "center",
      render: (text, record) => {
        return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
      } 
    } : {},
    currencyLlist.includes(11) ?
    {
      title: "XAU Bakiye",
      dataIndex: "amountXAU",
      key: "amountXAU",
      align: "center",
      render: (text, record) => {
        return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
      } 
    } : {},
    currencyLlist.includes(14) ?
    {
      title: "AUD Bakiye",
      dataIndex: "amountAUD",
      key: "amountAUD",
      align: "center",
      render: (text, record) => {
        return isDigitReportFromEndOfDay ? ColumnHelper.renderDecimal(text) : ColumnHelper.renderDecimal(text).split(",")[0]
      } 
    } : {},
  ];

  return (
    <>
     <DailyReportTableFilter
        onClearFilter={onClearTableFilter}
        monthly={true}
        amountModel={true}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={tableColumns.filter((column) => !column.isRowDetail)}
            expandable={{
              expandedRowRender: (row) =>
                detailTableBankAccounts(row.details),
            }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            rowKey={(record, index) => index}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default DailyBalanceReport;
